module.exports = __webpack_public_path__ + "img/bg.539a90b2.jpg";